import type { FieldValues, Path } from "react-hook-form";
import styled from "styled-components";
import type { SelectOption } from "@songtradr-one/components-frontend";
import type { BaseProps } from "../../FormField.Parts";

// TEXT

// STYLES
/**
 * @TODO
 * Temporary workaround for styling issues with Select component inside forms.
 * @SamGarry: Please remove SelectWrapper once Select component is fixed in components-frontend
 */
export const SelectWrapper = styled.div`
  div[role="button"] {
    background: transparent;
    height: 4rem;

    > div:first-child > div:first-child {
      height: 1rem;
      color: inherit;
    }

    > div:first-child > p {
      height: auto;
      max-height: 1.5rem;
    }
  }
`;

// DATA

// TYPES
export type Props<
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
> = BaseProps<FormFields, FieldName, string> & {
  type: "select";
  options: SelectOption[];
  placeholder?: string;
  search?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
